module.exports = __webpack_public_path__ + "images/help_v2/masthead_guides@2x-c0e5187717ec5d2469da17752b985e9d.png";